import { DenyBidValidationSchema } from "@next-pontos/validations";
import { useFormik } from "formik";
import { enqueueSnackbar } from "notistack";
import { Fragment, useContext, useEffect, useState } from "react";
import { Alert, Grid, Layout, Loader, Paper } from "../../components";
import AuthContext from "../../context/auth";
import { useAxios, useToggle } from '../../hooks';
import { AccountModalBids } from "./AccountModal";
import { DeleteBidsModal } from "./DeleteModal";
import { DenyBidsModal } from "./DenyModal";
import { BidsTable } from './Table';

export function Bids () { 
    const [bids, refetchBids] = useAxios('/bid')
    
    const [api, postAPI] = useAxios({
        method: 'POST'
    }, {
        manual: true
    })

    const [bid, fetchBid] = useAxios('/bid', {
        manual: true
    })

    const [, deleteBid] = useAxios('/bid', {
        manual: true
    })

    const { me } = useContext(AuthContext)
    const [deleteModalVisibility, deleteModalVisibilityControls] = useToggle(false)
    const [denyModalVisibility, denyModalVisibilityControls] = useToggle(false)
    const [accountModalVisibility, accountModalVisibilityControls] = useToggle(false)
    const [denyBidId, setDenyBidId] = useState<undefined | string | number>()
    const [deleteBidId, setDeleteBidId] = useState<undefined | string | number>()

    const denyFormik = useFormik({
        initialValues: {
            reason: ''
        },
        validationSchema: DenyBidValidationSchema,
        validateOnChange: true,
        validateOnMount: true,
        onSubmit: async (values) => {
            await postAPI({ url: `/bid/${denyBidId}/deny`, 
                data: values
            })

            denyModalVisibilityControls.setFalse()
            refetchBids()
        }
    })

    const handleDeleteBid = async () => {
        const { status } = await deleteBid({
            url: `/bid/${deleteBidId}`,
            method: 'DELETE',
        });

        if (status <= 299) {
            enqueueSnackbar('Oferta excluída com sucesso!', { variant: 'success' });
        }

        deleteModalVisibilityControls.setFalse();
        refetchBids();
    }
 
    useEffect(() => {
        if (!denyModalVisibility) {
            setDenyBidId(undefined)
        }
    }, [denyModalVisibility])

    return (
        <Fragment>
            <DenyBidsModal 
                denyModalVisibility={denyModalVisibility} 
                formik={denyFormik} 
                modalVisibilityControls={denyModalVisibilityControls}
            />
            <DeleteBidsModal
                modalVisibility={deleteModalVisibility}
                modalVisibilityControls={() => {
                    deleteModalVisibilityControls.setFalse();
                    setDeleteBidId('');
                }}
                onConfirm={handleDeleteBid}
            />
            <AccountModalBids 
                accountModalVisibility={accountModalVisibility} 
                accountModalVisibilityControls={accountModalVisibilityControls}
                bid={bid.data}
                loading={bid.loading}
            />
            <Layout>
                <Grid container justifyContent="center" padding={3} gap={2}>
                    {api.loading || bids.loading ? (
                        <div style={{
                            display: 'flex',
                            flex: '1',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Loader />
                        </div>
                    ) : (
                    <Fragment>
                        <Grid item xs={12} sm={11}>
                            <Alert color="info" icon={false}>
                                Esta listagem inicialmente apenas mostra ofertas com status <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Em Emissão</span> e <span style={{ fontWeight: 'bold', textTransform: 'uppercase' }}>Aguardando Emissão</span>.<br/>Para ver todos os registros, limpe os filtros da tabela.
                            </Alert>
                        </Grid>
                        <Grid item xs={12} sm={11}>
                        {
                            bids.data.find((item: { status: string }) => item.status === 'ON_ORDER') ? (
                                    <Alert color="warning" icon={false} sx={{marginBottom: 2}}>
                                        <strong>Você possui ofertas em emissão!</strong><br/>
                                        Não se esqueça de finalizar a oferta quando não houverem mais emissões a serem feitas.
                                    </Alert>
                            ) : null
                        }
                            <Paper elevation={1}>
                            <BidsTable 
                                setDeleteBidId={setDeleteBidId}
                                deleteModalVisibilityControls={deleteModalVisibilityControls}
                                setDenyBidId={setDenyBidId}
                                denyModalVisibilityControls={denyModalVisibilityControls}
                                accountModalVisibilityControls={accountModalVisibilityControls} 
                                fetchBid={fetchBid}
                                me={me}
                                refetchBids={refetchBids}
                                bids={bids}/>
                            </Paper>
                        </Grid>
                    </Fragment>)}
                </Grid>
            </Layout>
        </Fragment>
    )
}